module.exports = __webpack_public_path__ + "static/media/IMG_0556.21b12fdd.jpg";